import React, { useEffect } from "react";
import { Navigate, useLocation, useRoutes } from "react-router";
import { lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaxLayout from "../max-layout/MaxLayout";
import Login from "../pages/authentication/Login";
import Chat from "../pages/chat/Chat";
import DocumentUpload from "../pages/document-upload/DocumentUpload";
import UserAdmin from "../pages/user-admin/UserAdmin";
import AiTraining from "../pages/ai-taining/AiTraining";
import Dashboard from "../pages/dashboard/Dashboard";
import ContactPlan from "../pages/contact-plan/ContactPlan";
import AiRules from "../pages/ai-rules/AiRules";
import NotFound from "../pages/not-found/NotFound";
import SignUp from "../pages/authentication/SignUp";
import PrivateRoute from "../components/PrivateRoute";
import PublicRoute from "../components/PublicRoute";
import ChatService from "../services/chat";

const SuspenseLoader = (Component) => (props) =>
  (
    <React.Suspense fallback={<withLoader />}>
      <Component {...props} />
    </React.Suspense>
  );

const Home = SuspenseLoader(lazy(() => import("../max-layout/MaxLayout")));
function RedirectionWrapper({ to }) {
  const queryString = window.location.search;
  if (queryString) {
    return <Navigate to={`${to}${queryString}`} />;
  }
  return <Navigate to={to} />;
}
const routes = (isLogin) => [
  {
    path: "/",
    element: <MaxLayout />,
    children: [
      {
        element: <RedirectionWrapper to="/user-admin" />,
        index: true,
      },
      {
        path: "/chat",
        element: (
          <PrivateRoute>
            <Chat />
          </PrivateRoute>
        ),
      },
      {
        path: "/document-upload",
        element: (
          <PrivateRoute>
            <DocumentUpload />
          </PrivateRoute>
        ),
      },
      {
        path: "/user-admin",
        element: (
          <PrivateRoute>
            <UserAdmin />
          </PrivateRoute>
        ),
      },
      {
        path: "/ai-training",
        element: (
          <PrivateRoute>
            <AiTraining />
          </PrivateRoute>
        ),
      },
      {
        path: "/dashboard",
        element: (
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "/contact-plan",
        element: (
          <PrivateRoute>
            <ContactPlan />
          </PrivateRoute>
        ),
      },
      {
        path: "/ai-rules",
        element: (
          <PrivateRoute>
            <AiRules />
          </PrivateRoute>
        ),
      },
      {
        path: "*",
        element: (
          <PrivateRoute>
            <NotFound />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/sign-up",
    element: (
      <PublicRoute>
        <SignUp />
      </PublicRoute>
    ),
  },
  {
    path: "*",
    element: (
      <PrivateRoute>
        <NotFound />
      </PrivateRoute>
    ),
  },
];

// export default function Router() {
//   return useRoutes(routes());
// }
export default function Routes(props) {
  const chat = useSelector((state) => state.chat);
  console.log("🚀  Routes  chat:", chat);
  const location = useLocation();
  const dispatch = useDispatch();
  const { isLogin } = props;

  const clearSession = async () => {
    try {
      const response = await ChatService?.clearSession();
      console.log("🚀  clearSession  response:", response);
    } catch (error) {
      console.log("🚀  clearSession  error:", error);
    }
  };

  useEffect(() => {
    clearSession();
  }, [location.pathname, chat?.isInitial]);
  console.log(location.pathname);

  return useRoutes(routes(isLogin));
}
